import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { BIZ } from "../data/site";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[80svh] flex items-center">
      <Seo
        title="Page Not Found | Westway Collision Center"
        description="The page you requested was not found. Explore collision repair services or contact Westway Collision Center in Carrollton, TX."
        path="/404"
        robots="noindex, nofollow"
      />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center py-32">
        <p className="font-display text-7xl sm:text-8xl font-extrabold accent-text">404</p>
        <h1 className="mt-6 font-display text-2xl sm:text-4xl font-bold tracking-tight text-white">
          This Road Doesn&apos;t Exist
        </h1>
        <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">
          The page you asked for has moved or never existed. These will get you where you need to go:
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {[
            ["All Services", "/services"],
            ["Free Estimate", "/free-estimate"],
            ["Contact Us", "/contact"],
            ["Home", "/"],
          ].map(([label, to]) => (
            <Link
              key={to}
              to={to}
              data-testid={`404-link-${label.toLowerCase().replace(/\s/g, "-")}`}
              className="rounded-full border border-white/20 px-6 py-3 font-display text-sm font-semibold text-slate-200 transition-all duration-300 hover:border-accent/60 hover:text-accent"
            >
              {label}
            </Link>
          ))}
        </div>
        <p className="mt-8 text-sm text-slate-500">
          Or call <a href={BIZ.phoneHref} className="text-accent hover:text-accentdeep transition-colors">{BIZ.phoneDisplay}</a> — a person answers.
        </p>
      </div>
    </div>
  );
}
